SET_USER_ACCOUNT_PAUSE_LENGTH